import { ActionResult } from '~/hooks/actions/enums';
import type { ActionHandler } from '~/hooks/actions/types';
import logger from '~/services/logger';
import type { FeedEntry } from '~/services/layout/index.ts';
import { QueueManager, setupClientQueue } from '../index.ts';

type AddToQueueOptions = {
  entry?: FeedEntry;
};

/**
 * Adds an entry to QueueManager, matching QuickBrick queue-action behavior.
 */
export const addToQueueAction: ActionHandler<AddToQueueOptions> = async (
  action
) => {
  setupClientQueue();

  const options = action.options ?? {};
  const contextEntry = (action.context as { entry?: FeedEntry } | undefined)
    ?.entry;

  const entry = options.entry ?? contextEntry;

  if (!entry?.id) {
    logger.info('addToQueueAction: missing item or entry id');
    return ActionResult.Error;
  }

  try {
    await QueueManager.instance.addToQueue(entry);
    return ActionResult.Success;
  } catch (error) {
    logger.error(`addToQueueAction: failed to add item: ${error}`);
    return ActionResult.Error;
  }
};
